<template>
  <div class="row p-md-5 mx-md-3 mb-5">
    <div class="col-12">
      <div class="row justify-content-center">
        <div class="col-md-3 text-center">
          <div class="row">
            <div class="col-12 mt-md-3 text-center">
              <h3 class="mt-md-5 mt-3">Prueba</h3>
            </div>
            <div class="col-12 mb-md-3 text-center">
              <h2 class="mb-md-5 mb-3">BDI-II</h2>
            </div>
          </div>
          <div class="row d-none d-md-block">
            <div class="col-12 mt-3 text-center">
              <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <ul class="nav nav-tabs mx-3" id="myTab" role="tablist">
            <li class="nav-item text-center w-50">
              <a class="nav-link active " id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                <h4>Instrucciones</h4>
              </a>
            </li>
            <li class="nav-item text-center w-50">
              <a class="nav-link" id="home2-tab" data-toggle="tab" href="#home2" role="tab" aria-controls="home2" aria-selected="true">
                <h4>Ejemplo</h4>
              </a>
            </li>
          </ul>
          <div class="tab-content mx-2" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div class="row mt-4">
                <div class="col-12 text-center">
                  <b>Instrucciones</b>
                </div>
                <div class="col-12 mt-3">
                  Este cuestionario consiste en 21 grupos de afirmaciones.
                </div>
                <div class="col-12 mt-3">
                   Por favor, lea con atención cada uno de ellos y, a continuación, señale cuál de las afirmaciones de cada grupo describe mejor el modo en el que se ha sentido <b>DURANTE LAS DOS ÚLTIMAS SEMANAS, INCLUYENDO EL DÍA DE HOY</b>.
                </div>
                <div class="col-12 text-center mt-3">
                  <b>Al contestar tenga en cuenta lo siguiente.</b>
                </div>
                <div class="col-12 mt-3">
                  No piense demasiado las preguntas ni emplee mucho tiempo en decidirse.
                </div>
                <div class="col-12 mt-3">
                  Conteste sinceramente. No señale sus respuestas pensando en lo que "es bueno" o "lo que interesa" para impresionar al examinador.
                </div>
              </div>
            </div>
            <div class="tab-pane fade show" id="home2" role="tabpanel" aria-labelledby="home2-tab">
              <div class="row mt-3">
                <div class="col-12">
                  Tal vez algunas preguntas le parezcan muy personales; no se preocupe y recuerde que las respuestas se guardan como información confidencial; por otra parte, al obtener los resultados no se consideran las respuestas una a una, sino globalmente.
                </div>
                <div class="col-12 mt-3">
                  <b>Seleccionar respuesta:</b>
                </div>
                <div class="col-12 mt-3">
                  1. Posicione la flecha del mouse sobre el texto de la respuesta deseada.
                </div>
                <div class="col-12 mt-3">
                  2. Presione el botón izquierdo del mouse para marcar la respuesta.
                </div>
                <div class="col-12 mt-3">
                  <b>Cancelar respuesta:</b>
                </div>
                <div class="col-12 mt-3">
                  1. Posicione la flecha del mouse en la respuesta a cancelar.
                </div>
                <div class="col-12 mt-3">
                  2. Presione el botón izquierdo del mouse para quitar la marca a la respuesta.
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Elige una opción</th>
                        <th scope="col" class="text-center"></th>
                      </tr>
                    </thead>
                    <tbody v-for="pregunta of ejemplo.preguntas" v-if="pregunta.active">
                      <tr>
                        <td rowspan="3">{{pregunta.numero}}</td>
                        <td>
                          <div class="row">
                            <div
                              v-for="respuesta of pregunta.respuestas"
                              v-on:click="Seleccionar_Respuesta(pregunta.numero, respuesta.numero)" 
                              class="col-12 border-secondary pb-3 mb-3 border-bottom select_respuesta">
                              <div class="row">
                                <div class="col-9">
                                  {{respuesta.respuesta}}
                                </div>
                                <div class="col-3">
                                  <i 
                                    v-if="pregunta.respuesta===respuesta.numero" class="fas fa-check" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5 text-center d-block d-md-none">
          <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      ejemplo:{
        preguntas:[
          {
            numero:1,
            active:true,
            nompregunta: '',
            respuesta: null,
            respuestas:[
              {numero:1,respuesta:'No me siento triste habitualmente'},
              {numero:2,respuesta:'Me siento triste gran parte del tiempo'},
              {numero:3,respuesta:'Me siento triste continuamente'},
              {numero:4,respuesta:'Me siento tan triste o tan desgraciado que no puedo soportarlo'},
            ]
          },
        ]
      }
    }
  },
  methods:{
    Seleccionar_Respuesta(numero_pregunta,respuesta){
      const pregunta = this.ejemplo.preguntas.filter(function (pregunta) {
            return pregunta.active == true;
        })

        if (pregunta[0].respuesta === respuesta) pregunta[0].respuesta = ''
        else pregunta[0].respuesta = respuesta
    },
    Iniciar_Examen(){
      this.$router.push({name:'depBeck_preguntas'});
    },
    Cargando(){
      this.loading='';
      this.result='d-none';
    },
    Listo(){
      this.loading='d-none';
      this.result='';
    }
  }
};
</script>

<style>
.select_respuesta{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Examenes/DepresionBeck/Instrucciones.vue